<template>
    <div>
        <div v-if="dentitionData">
            <DentitionPlan
                v-for="(billedDentitions, type) in dentitionData.patient_dentitions"
                :key="type"
                :dentition="dentitionData.dentitions"
                :dentitionType="type"
                :selectedDentitions="Object.keys(billedDentitions)"
                class="mb-3"
                @onSelectDentition="onSelectDentition"
            />
        </div>

        <BilledDentitionModal
            v-if="isShowBillingDetail"
            v-model:isShowBillingDetail="isShowBillingDetail"
            :tableItems="selectedGenerals"
        />
    </div>
</template>

<script setup>
import {inject, onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import handleDentalOs from '@/services/modules/dental-os/dentalOs';
import { cloneDeep } from 'lodash';
import DentitionPlan from '@/components/molecule/company/dental-os/single-service/patients/tabs/components/DentitionPlan.vue';
import BilledDentitionModal from '@/components/molecule/company/dental-os/single-service/patients/tabs/components/BilledDentitionModal.vue';

const { fetchBilledDentition } = handleDentalOs();

const route = useRoute();

const loading = ref(false);
const isShowBillingDetail = ref(false);

const dentitionData = ref(null);
const selectedGenerals = ref([]);

const onSelectDentition = ({toothNumber, type}) => {
    selectedGenerals.value = dentitionData.value.patient_dentitions[type][toothNumber];
    isShowBillingDetail.value = true;
}

const getBilledDentition = async (contactId) => {
    const query = getQuery();
    loading.value = true

    await fetchBilledDentition(contactId, query).then(res => {
        if (!res.status) return;
        dentitionData.value = res.data;
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    return query;
}

watch(() => route.query.contactId, (contactId) => {
    if (!contactId) return;
    getBilledDentition(contactId)
}, { immediate: true, deep: true })
</script>